export const SUSPICIOUS_CUSTOMERS_FILTERS = {
  "Account id": "accounts_id",
  Name: "name",
  Email: "email",
  Note: "note",
};
